import { Box, Breadcrumbs, Button, Link, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActiveElements } from '../../hooks/useActiveElements'
import { navbarRoutes } from '../../router/navbar-routes'
import { justifyCenter } from '../../styles'

export const DeskMenu = () => {
  const navigate = useNavigate()

  const handleNavigate = (route) => {
    navigate(`${route}`)
  }

  return (
    <div role="presentation" className="desk__menu">

        {
          navbarRoutes.map(({ title, route, component, active }, index) => (
            <Button onClick={() => handleNavigate(route, index)} underline="hover" startIcon={component} variant={active ? 'contained' : ''}>{title}</Button>
          ))
        }
    </div>
  )
}
